import { Box, Typography } from '@mui/material'

import { useEngineeringUi } from 'components/WellPages/Engineering/Utils/EngineeringStyling'

const DataConfigFormItem = ({
  item = {}, // { label: '', tags: [] }
  label = item?.label ?? '',
  children,
  extra = null,
  reverse = false,
  labelWidth = 110,
  labelWidthXs = 90,
  controlMaxWidth = null,
  alignItems = 'center',
  justifyContent = 'start',
  columnGap = 1,
  rowGap = 1,
  sx = {},
}) => {
  const ui = useEngineeringUi(true)
  const isEditable = true // *** fix

  return (
    <Box
      sx={{
        display: 'grid',
        alignItems,
        justifyContent,
        columnGap,
        rowGap,
        minWidth: 0,
        gridTemplateColumns: {
          xs: reverse ? `minmax(0, 1fr) ${labelWidthXs}px` : `${labelWidthXs}px minmax(0, 1fr)`,
          md: reverse ? `minmax(0, 1fr) ${labelWidth}px` : `${labelWidth}px minmax(0, 1fr)`,
        },
        ...sx,
      }}>
      <Box
        sx={{
          display: 'inline-flex',
          order: reverse ? 2 : 1,
          justifyContent: justifyContent,
          alignItems: 'center',
          gap: 0.5,
          minWidth: 0,
        }}>
        {labelWidth > 0 && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
            <Typography sx={{ ...ui.label, whiteSpace: 'wrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {label ?? ''}
            </Typography>
          </Box>
        )}
      </Box>
      <Box
        sx={{
          order: reverse ? 1 : 2,
          minWidth: 0,
          maxWidth: '100%',
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          flexWrap: 'nowrap',
          overflow: 'hidden',
          opacity: isEditable ? 1 : 0.7,
        }}>
        <Box
          sx={{
            minWidth: 0,
            maxWidth: controlMaxWidth || '100%',
            flex: controlMaxWidth ? '0 1 auto' : '1 1 auto',
          }}>
          {children}
        </Box>

        {extra ? (
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.25,
              whiteSpace: 'nowrap',
              flex: '0 0 auto',
              minWidth: 0,
            }}>
            {extra}
          </Box>
        ) : null}
      </Box>
    </Box>
  )
}

export default DataConfigFormItem
